import { Component, inject, ChangeDetectionStrategy, input } from '@angular/core';
import { SessionService } from '../../../app/services/session.service';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { LayoutService } from '../../services/layout.service';
import { Breadcrumb } from './Breadcrumb';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { BreadCrumbService } from './BreadCrumbService';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { MatIcon } from '@angular/material/icon';

@Component({
	selector: 'vex-breadcrumbs',
	templateUrl: 'breadcrumbs.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslocoDirective, BreadcrumbComponent, RouterLink, MatIcon],
})
export class BreadcrumbsComponent {
	sessionService = inject(SessionService);
	translocoService = inject(TranslocoService);
	layoutService = inject(LayoutService);
	private activatedRoute = inject(ActivatedRoute);

	private breadCrumbService = inject(BreadCrumbService);
	readonly crumbs = input<Breadcrumb[]>([]);

	get_route_for_crumb(crumb: Breadcrumb) {
		if (!crumb) {
			return '/dashboard';
		}
		let ret;

		const paramMap = this.activatedRoute.snapshot.paramMap;
		// catch specific device
		if (crumb.translationKey === 'devices.detail.title') {
			if (paramMap.has('tenantUnitId')) {
				return '/realestates/' + paramMap.get('realEstateId') + '/tenantunits/' + paramMap.get('tenantUnitId') + '/devices/' + paramMap.get('deviceId');
			}
			return '/realestates/' + paramMap.get('realEstateId') + '/devices/' + paramMap.get('deviceId');
		} else if (crumb.translationKey === 'workOrders.workOrderDetails') {
			ret = '/work-orders/';
			if (paramMap.has('workOrderNumber')) {
				ret += paramMap.get('workOrderNumber');
			}
			return ret;
		} else if (crumb.translationKey === 'workOrders.workOrderTaskDetails') {
			ret = '/work-orders/' + paramMap.get('workOrderNumber');
			ret += '/task/';
			if (paramMap.has('taskId')) {
				ret += paramMap.get('taskId');
			}
			return ret;
		} else {
			switch (crumb.translationKey) {
				case 'sideboard.tenantunits':
					return '/realestates/' + paramMap.get('realEstateId');

				case 'realestates.realestates':
					return '/realestates';

				case 'sideboard.realestate':
				case 'realestates.realestate':
					return '/realestates/' + paramMap.get('realEstateId');

				case 'sideboard.consumptionInfo':
					return '/consumptionInformations';

				case 'sideboard.tenantunitDetails':
					return '/realestates/' + paramMap.get('realEstateId') + '/tenantunits/' + paramMap.get('tenantUnitId');

				case 'sideboard.massPrint':
					return '/mass-printing';

				case 'development.development':
					return '/development';

				case 'permissions.permissions':
					return '/permissions/';

				case 'settings.settings':
				case 'sideboard.settings':
					return '/settings/';

				case 'sideboard.uvi':
					return '/uvi';

				case 'sideboard.billings':
					return '/billing-units';

				case 'billing.billingUnits':
					return '/billing-units';

				case 'supportAraApp.title':
					return '/ara-app/';

				case 'billing.billingUnit':
					return '/billing-units';

				case 'billing.billing':
					return '/billing-units/' + sessionStorage.getItem('selectedBillingId') + '/periods/' + sessionStorage.getItem('selectedPeriodId');

				case 'sideboard.development':
				case 'development.apiDocu':
					return '/development';

				case 'documentTransfer.title':
					return '/document-transfer';

				default:
					return '/dashboard';
			}
		}
	}
}
